import React, { useState } from 'react';
import styled, { css } from 'styled-components';

import { IfPermitted } from 'components/common';
import { Col, Row } from 'components/bootstrap';
import type { CollectionDetail } from 'collections/types';

import CollectionEntitiesList from './CollectionEntitiesList/CollectionEntitiesList';
import AddEntitiesModal from './AddEntitiesModal';

type Props = {
  collection: CollectionDetail;
};

const EntitiesHeaderCol = styled(Col)(
  ({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: ${theme.spacings.sm};
  `,
);

const CollectionDetails = ({ collection }: Props) => {
  const [showAddModal, setShowAddModal] = useState<boolean>(false);

  return (
    <IfPermitted permissions={`collection_entities:list:${collection.id}`}>
      <Row className="content">
        <Col md={12}>
          <Row>
            <EntitiesHeaderCol md={12}>
              <h2>Collection Content</h2>
            </EntitiesHeaderCol>
          </Row>
          <Row>
            <Col md={12}>
              <CollectionEntitiesList collectionId={collection.id} collectionTitle={collection.title} />
            </Col>
          </Row>
        </Col>
      </Row>

      {showAddModal && <AddEntitiesModal collectionId={collection.id} onClose={() => setShowAddModal(false)} />}
    </IfPermitted>
  );
};
export default CollectionDetails;
